import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import { ArrowLeft } from 'lucide-react';

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0a0a0f] via-[#1a1a2e] to-[#0a0a0f] flex flex-col">
      <SEO
        title="Privacy Policy | Charles Kilvington"
        description="Privacy Policy for charleskilvington.com"
        ogTitle="Privacy Policy | Charles Kilvington"
        ogDescription="Privacy Policy for charleskilvington.com"
        ogUrl="https://charleskilvington.com/privacy"
        ogImage="https://charleskilvington.com/og-image.jpg"
        twitterImage="https://charleskilvington.com/og-image.jpg"
      />
      <Header />

      <main className="pt-28 md:pt-36 pb-16 px-8 flex-1">
        <div className="max-w-[900px] mx-auto">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors mb-8 group"
          >
            <ArrowLeft size={20} className="group-hover:-translate-x-1 transition-transform" />
            <span className="font-medium">BACK</span>
          </button>
          <div className="text-center mb-16">
            <h2 className="text-transparent bg-clip-text bg-gradient-to-r from-purple-400 via-pink-400 to-purple-600 font-['Poppins'] text-6xl font-black mb-6">
              PRIVACY POLICY
            </h2>
            <div className="h-1 w-32 bg-gradient-to-r from-purple-500 to-pink-500 mx-auto rounded-full"></div>
          </div>

          <div className="glass-effect rounded-2xl p-8 md:p-12 space-y-8">
            <div>
              <p className="text-gray-400 mb-8">
                Last Updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
              </p>
            </div>

            <section>
              <h3 className="text-white font-['Poppins'] text-2xl font-bold mb-4">
                1. Information We Collect
              </h3>
              <p className="text-gray-300 leading-relaxed">
                When you use the contact form on this website, we collect your name, email address, and the message you provide. This information is used solely to respond to your inquiry.
              </p>
            </section>

            <section>
              <h3 className="text-white font-['Poppins'] text-2xl font-bold mb-4">
                2. How We Use Your Information
              </h3>
              <p className="text-gray-300 leading-relaxed mb-4">
                The information collected through the contact form is used to:
              </p>
              <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4">
                <li>Respond to your inquiries and communications</li>
                <li>Provide information about services you've requested</li>
                <li>Maintain records of our communications</li>
              </ul>
            </section>

            <section>
              <h3 className="text-white font-['Poppins'] text-2xl font-bold mb-4">
                3. Analytics
              </h3>
              <p className="text-gray-300 leading-relaxed">
                This website uses Google Analytics to understand how visitors interact with the site. Google Analytics collects information anonymously and reports website trends without identifying individual visitors. You can opt out of Google Analytics by installing the Google Analytics opt-out browser add-on.
              </p>
            </section>

            <section>
              <h3 className="text-white font-['Poppins'] text-2xl font-bold mb-4">
                4. Data Security
              </h3>
              <p className="text-gray-300 leading-relaxed">
                We implement appropriate security measures to protect your personal information. However, no method of transmission over the internet is 100% secure, and we cannot guarantee absolute security.
              </p>
            </section>

            <section>
              <h3 className="text-white font-['Poppins'] text-2xl font-bold mb-4">
                5. Third-Party Services
              </h3>
              <p className="text-gray-300 leading-relaxed">
                This website may contain links to third-party websites. We are not responsible for the privacy practices of these external sites and encourage you to read their privacy policies.
              </p>
            </section>

            <section>
              <h3 className="text-white font-['Poppins'] text-2xl font-bold mb-4">
                6. Your Rights
              </h3>
              <p className="text-gray-300 leading-relaxed">
                You have the right to request access to, correction of, or deletion of your personal information. To exercise these rights, please contact us using the information provided on our Contact page.
              </p>
            </section>

            <section>
              <h3 className="text-white font-['Poppins'] text-2xl font-bold mb-4">
                7. Changes to This Policy
              </h3>
              <p className="text-gray-300 leading-relaxed">
                We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated revision date.
              </p>
            </section>

            <section>
              <h3 className="text-white font-['Poppins'] text-2xl font-bold mb-4">
                8. Contact Information
              </h3>
              <p className="text-gray-300 leading-relaxed">
                If you have any questions about this Privacy Policy, please contact us through our Contact page.
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
